import axios from "axios";
import { authHeader } from "./utils";
import { LIST_EVENT, LIST_EVENT_ALERT } from "./types";

export const fetchEvents =
  (page = 0, limit = 10) =>
  async (dispatch) => {
    const res = await axios.get("/api/events", {
      headers: authHeader(),
      params: { page, limit },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_EVENT, payload: res.data });
  };

export const fetchEventAlerts =
  (limit = 3) =>
  async (dispatch) => {
    const res = await axios.get("/api/events", {
      headers: authHeader(),
      params: { page: 0, limit, target: "alert" },
    });
    console.log("res", res.data);
    dispatch({ type: LIST_EVENT_ALERT, payload: res.data });
  };

export const updateEventAlert =
  ({ alert, id }) =>
  async (dispatch) => {
    try {
      const res = await axios.put(`/api/events/${id}`, alert, {
        headers: authHeader(),
      });
      console.log("res", res.data);
      dispatch(fetchEventAlerts()).then(() => {
        dispatch(fetchEvents(0, 10));
      });
    } catch ({ message, original }) {
      console.log(message, original);
    }
  };
